module.exports = __webpack_public_path__ + "static/media/gorls.29e5eb75.png";